
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, label = "Phone Number" }) => {
  // Format phone number as user types (e.g., (555) 123-4567)
  const formatPhoneNumber = (input: string): string => {
    const digits = input.replace(/\D/g, "").substring(0, 10);
    
    if (digits.length === 0) return "";
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
    return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    onChange(formatted);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="phone">{label}</Label>
      <Input
        id="phone"
        type="tel"
        placeholder="(555) 123-4567"
        value={value}
        onChange={handleChange}
        className="text-base md:text-lg py-4 md:py-6"
      />
    </div>
  );
};

export default PhoneInput;
